import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ManualClusterSelect from '../../../components/manualClusterModal';

class ExtraButtons extends Component {
    constructor(props) {
        super();

        this.changeFirstPosition = this.changeFirstPosition.bind(this);
        this.changeSecondPosition = this.changeSecondPosition.bind(this);
        this.changeWeeks = this.changeWeeks.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitWeeks = this.onSubmitWeeks.bind(this);

        this.state = {
            first_position: props.first_position ?? 4,
            second_position: props.second_position ?? 11,
            error: '',
            weeks: props.weeks ?? 4,
        };
    }

    openModal(e) {
        e.stopPropagation();
    }

    changeFirstPosition(e) {
        const value = e.target.value;
        this.setState({
            first_position: value,
            error: '',
        });
    }

    changeSecondPosition(e) {
        const value = e.target.value;
        this.setState({
            second_position: value,
            error: '',
        });
    }

    changeWeeks(e) {
        const value = e.target.value;
        this.setState({
            weeks: value,
        });
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.state.second_position <= this.state.first_position) {
            return this.setState({
                error: this.props.t('search.striking_distance.extraBtns.check_numbers_error'),
            });
        }

        this.props.changePositions(this.state.first_position, this.state.second_position);
    }

    onSubmitWeeks(e) {
        e.preventDefault();
        this.props.changeWeek(this.state.weeks);
    }

    render() {
        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btns-modal-sm">
                        <button
                            id="dropdownRankingPosition"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="head-btn"
                        >
                            {this.props.t('search.striking_distance.extraBtns.ranking')}
                            <i className="icon-fi_chevron-down" />
                        </button>
                        <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownRankingPosition"
                            id="position-dropdown"
                        >
                            <div className="dropdown-menu-header">
                                {this.props.t(
                                    'search.striking_distance.extraBtns.ranking_position',
                                )}
                            </div>
                            <div className="dropdown-menu-body">
                                <form onSubmit={this.onSubmit}>
                                    <div className="d-flex gap-12 justify-content-between">
                                        <div className="form-field-striking">
                                            <label>
                                                {this.props.t(
                                                    'search.striking_distance.extraBtns.from',
                                                )}
                                            </label>
                                            <input
                                                onChange={this.changeFirstPosition}
                                                value={this.state.first_position}
                                                type="number"
                                            />
                                        </div>
                                        <div className="form-field-striking">
                                            <label>
                                                {this.props.t(
                                                    'search.striking_distance.extraBtns.to',
                                                )}
                                            </label>
                                            <input
                                                onChange={this.changeSecondPosition}
                                                value={this.state.second_position}
                                                type="number"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end mt-10">
                                        <button className="button button-primary button-filled">
                                            {this.props.t(
                                                'search.striking_distance.extraBtns.apply_filter',
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <button
                            id="dropdownNumberOfWeeks"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="head-btn"
                        >
                            {this.props.t('search.striking_distance.extraBtns.no_of_weeks')}
                            <i className="icon-fi_chevron-down" />
                        </button>
                        <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownNumberOfWeeks"
                            id="number-dropdown"
                        >
                            <div className="dropdown-menu-header">
                                {this.props.t('search.striking_distance.extraBtns.number_of_weeks')}
                            </div>
                            <div className="dropdown-menu-body">
                                <form onSubmit={this.onSubmitWeeks}>
                                    <div className="form-field-striking w-100">
                                        <label>
                                            {this.props.t(
                                                'search.striking_distance.extraBtns.check_nweeksumbers_error',
                                            )}
                                        </label>
                                        <input
                                            type="numer"
                                            onChange={this.changeWeeks}
                                            value={this.state.weeks}
                                            className="striking-extra-input"
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end mt-10">
                                        <button className="button button-primary button-filled">
                                            {this.props.t(
                                                'search.striking_distance.extraBtns.apply_filter',
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <ManualClusterSelect
                    current_url={this.props.current_url}
                    csrf_token={this.props.csrf_token}
                    selectedItems={this.props.selectedItems}
                    cluster_type="keyword"
                    header={this.props.t('search.striking_distance.extraBtns.add_to_keyword_list')}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
            </div>
        );
    }
}

export default withTranslation()(ExtraButtons);
